export default __webpack_public_path__ + "static/media/success_modal_icon.05c7b59f.svg";